import { render } from "./TestCheck.vue?vue&type=template&id=4158d3bd&scoped=true&ts=true"
import script from "./TestCheck.vue?vue&type=script&lang=ts"
export * from "./TestCheck.vue?vue&type=script&lang=ts"

import "./TestCheck.vue?vue&type=style&index=0&id=4158d3bd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/octopus-lobby/octopus-lobby/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4158d3bd"]])

export default __exports__